<template>
  <div class="tsBar flex" :class="{ show: !isFold }">
    <img src="~images/granary/ts-bar-bg4.png" alt="" />
    <!--
    <div class="ts-item" v-for="(item, i) in imgList" :key="i">
      <img :src="item" alt="" />
    </div> -->
  </div>
</template>

<script>
// import { get } from "@/api/index";
export default {
  data() {
    return {
      isFold: false,
      imgList: [
        require("images/granary/ts01.png"),
        require("images/granary/ts02.png"),
        require("images/granary/ts03.png")
      ]
    };
  },
  mounted() {
    this.$bus.$on("foldchange", val => {
      console.log("foldchange", val);
      this.isFold = val;
    });
  },
  methods: {},
  destroyed() {
    this.$bus.$off("foldchange");
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.tsBar
  // background url("~images/granary/ts-bar-bg.png") no-repeat center
  background-color rgba(1,22,76, 0.7)
  position absolute
  top 0
  // top 180px
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 0
  transition .3s
  // justify-content space-between
  // height .35rem
  >img
    max-width 100%
    height 0
    display block
    margin 0 auto
  .ts-item
    >img
      width 100%
    &:nth-of-type(1)
      width 28%
    &:nth-of-type(2)
      width 28%
    &:nth-of-type(3)
      width 44%
.tsBar.show
  top 180px
  z-index 1
  >img
    height auto
</style>
